export default __webpack_public_path__ + "static/media/Sierra Leone.738becf5.svg";